import { useSelector } from 'react-redux'

export default function usePlatformsList() {
    return useSelector(
        ({ app: { login: { platforms = [] } = {} } = {} }) => platforms
    )
}
